'use client';
import React from 'react';
import Section from '../../elements/Section';
import Title from '../../elements/Title';
import List, { ListItem } from '../../elements/List';
import Link from '../../components/Link';
import { classes, PRESS_RELEASES } from './utils';

export default function Page() {
  return (
    <div className={classes.wrapper}>
      <Section>
        <Title>Press Releases</Title>
        <List>
          {PRESS_RELEASES.map((pressRelease, i) => (
            <ListItem key={i}>
              <Link href={pressRelease.href} target="_blank">
                {pressRelease.name}
              </Link>
            </ListItem>
          ))}
        </List>
      </Section>
    </div>
  );
}
